module.exports = __webpack_public_path__ + "assets/images/65593660ffd2ea0185d86ce7364a4d5a.avif";